<section id="services" class="services section">
    <!-- Section Title -->
    <div class="container section-title" data-aos="fade-up">
        <h2>Our <span>Services</span></h2>
        <p>Comprehensive Invoicing Services Tailored to Your Business</p>
    </div><!-- End Section Title -->

    <div class="container">
        <div class="row g-5">
            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                <div class="service-item item-cyan position-relative">
                    <i class="bi bi-palette icon"></i>
                    <div>
                        <h3>Professional Design Templates</h3>
                        <p>Our platform offers a selection of professionally designed templates to give your invoices a
                            polished and professional look. Choose from a variety of styles to match your brand and
                            impress your clients.</p>
                        <!-- <a href="service-details.html" class="read-more stretched-link">Learn More <i
                                class="bi bi-arrow-right"></i></a> -->
                    </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
                <div class="service-item item-orange position-relative">
                    <i class="bi bi-receipt icon"></i>
                    <div>
                        <h3>Tax Calculation</h3>
                        <p>Simplify your tax calculations with our built-in tax calculator. Input your tax rates, and
                            our platform will automatically calculate the tax amount for each invoice, ensuring accuracy
                            and compliance.</p>
                        <!-- <a href="service-details.html" class="read-more stretched-link">Learn More <i
                                class="bi bi-arrow-right"></i></a> -->
                    </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="300">
                <div class="service-item item-teal position-relative">
                    <i class="bi bi-briefcase icon"></i>
                    <div>
                        <h3>Business Details</h3>
                        <p>Easily add your business details to each invoice, including your GST#, HST#, and business
                            website link. This ensures that your invoices comply with legal requirements and provides
                            your clients with essential information about your business.</p>
                        <!-- <a href="service-details.html" class="read-more stretched-link">Learn More <i
                                class="bi bi-arrow-right"></i></a> -->
                    </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="400">
                <div class="service-item item-red position-relative">
                    <i class="bi bi-file-earmark-spreadsheet icon"></i>
                    <div>
                        <h3>Invoice Customization</h3>
                        <p>Tailor your invoices to suit your business needs with our customization options. Add your
                            logo, change colors, and adjust the layout to create professional invoices that reflect your
                            brand identity.</p>
                        <!-- <a href="#" class="read-more stretched-link">Contact Us<i
                                class="bi bi-arrow-right"></i></a> -->
                    </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="500">
                <div class="service-item item-indigo position-relative">
                    <i class="bi bi-truck icon"></i>
                    <div>
                        <h3>Shipping Charges and Discounts</h3>
                        <p>Manage shipping charges and discounts effortlessly with our invoicing platform. Specify
                            shipping costs and apply discounts as needed, and our platform will calculate the total
                            amount due accurately.</p>
                        <!-- <a href="service-details.html" class="read-more stretched-link">Learn More <i
                                class="bi bi-arrow-right"></i></a> -->
                    </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="600">
                <div class="service-item item-pink position-relative">
                    <i class="bi bi-calculator icon"></i>
                    <div>
                        <h3>Live Calculations</h3>
                        <p>See totals update in real-time with our live calculation feature. As you add or remove items
                            from your invoice, the totals will adjust automatically, ensuring that your invoices are
                            always accurate.</p>
                        <!-- <a href="service-details.html" class="read-more stretched-link">Learn More <i
                                class="bi bi-arrow-right"></i></a> -->
                    </div>
                </div>
            </div><!-- End Service Item -->
        </div>
    </div>
</section>